import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb, Sidebar, Menu, Icon, Segment, Header } from 'semantic-ui-react'
import { SupportContainer } from './styled'
import { AdminContainer } from '../styled'
import { rootPath, adminPath } from 'routes'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'

import ChangePRCreatorAndRequester from './ChangePRCreatorAndRequester'
import CancelPR from './CancelPR'
import CancelGR from './CancelGR'
import CancelBilling from './CancelBilling'
import AddDummyUser from './AddDummyUser'
import UpdateLivNo from './UpdateLivNo'
import { menuConst } from './helper'

const Support = (props) => {
  const { user, history } = props

  useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    if (user) {
      if (user.isAdmin === false) {
        history.replace(rootPath)
      }
    }
  }, [user])

  const [menuSelected, setMenuSelected] = useState({menu:'',title:''})

  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Support</div>
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'Admin', content: 'Admin', link: true, onClick: () => history.push(adminPath) },
              { key: 'Support', content: 'Support', active: true }
            ]
          }
        />
      </div>
      <SupportContainer>
        <Sidebar.Pushable as={Segment} style={{ display: 'flex' }}>
          <Sidebar
            as={Menu}
            animation='overlay'
            icon='labeled'
            inverted
            vertical
            visible
            width='thin'
            style={{ position: 'inherit' }}
          >
            <Menu.Item as='a' onClick={() => setMenuSelected({menu:menuConst.M001, title:'Change PR Requester or Creator'})}>
              Change PR Requester or Creator
            </Menu.Item>
            <Menu.Item as='a' onClick={() => setMenuSelected({menu:menuConst.M002, title:'Cancel PR'})}>
              Cancel PR
            </Menu.Item>
            <Menu.Item as='a' onClick={() => setMenuSelected({menu:menuConst.M003, title:'Cancel GR'})}>
              Cancel GR
            </Menu.Item>
            <Menu.Item as='a' onClick={() => setMenuSelected({menu:menuConst.M004, title:'Cancel Billing'})}>
              Cancel Billing
            </Menu.Item>
            <Menu.Item as='a' onClick={() => setMenuSelected({menu:menuConst.M005, title:'Add dummy user'})}>
              Add dummy user
            </Menu.Item>
            <Menu.Item as='a' onClick={() => setMenuSelected({menu:menuConst.M006, title:'Update LIV No. (Not GR Based IV)'})}>
              Update LIV No.
            </Menu.Item>
          </Sidebar>

          <Sidebar.Pusher style={{ display: 'flex', flex: 1 }}>
            <Segment basic style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
              <Header as='h3'>{menuSelected.title}</Header>
              { menuSelected.menu === menuConst.M001 ? <ChangePRCreatorAndRequester /> : null }
              { menuSelected.menu === menuConst.M002 ? <CancelPR /> : null }
              { menuSelected.menu === menuConst.M003 ? <CancelGR /> : null }
              { menuSelected.menu === menuConst.M004 ? <CancelBilling /> : null }
              { menuSelected.menu === menuConst.M005 ? <AddDummyUser /> : null }
              { menuSelected.menu === menuConst.M006 ? <UpdateLivNo /> : null }
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </SupportContainer>
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    collapseMenu: state.app.collapseSideMenu,
  })
}

const mapDispatchToProps = {
  toggleSideMenu
}

export default connect(mapStateToProps, mapDispatchToProps)(Support)